import { call, put, takeEvery } from "redux-saga/effects"
// Crypto Redux States
import RtwInventoryTypes from "./actionTypes"
import RtwInventoryAction from "./actions"
import RtwInventoryAPI from "helpers/rtw-inventory_backend_helper"

function* fetchListOnPage({ payload }) {
  yield put(
    RtwInventoryAction.getListPageSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    const currentPage = payload.page
    delete payload.seasonName
    let { data } = yield call(RtwInventoryAPI.getListPage, {
      ...payload,
      page: currentPage,
    })
    yield put(
      RtwInventoryAction.getListPageSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    yield put(
      RtwInventoryAction.getListPageSuccess({
        loading: false,
        data: {},
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchDetail({ payload, action }) {
  yield put(
    RtwInventoryAction.getDetailSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let { data } = yield call(RtwInventoryAPI.getDetail, payload)

    action(data)
    yield put(
      RtwInventoryAction.getDetailSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    console.log(error)
    yield put(
      RtwInventoryAction.getDetailSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchPutData({ payload, action }) {
  yield put(
    RtwInventoryAction.putDataSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let { data } = yield call(RtwInventoryAPI.putData, payload)

    yield put(
      RtwInventoryAction.putDataSuccess({
        loading: false,
        data,
      })
    )
    action()
  } catch (error) {
    console.log(error)
    yield put(
      RtwInventoryAction.putDataSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* rtwInventorySaga() {
  yield takeEvery(RtwInventoryTypes.GET_RTW_INVENTORY_PAGES, fetchListOnPage)
  yield takeEvery(RtwInventoryTypes.GET_DETAIL_RTW_INVENTORY_BY_ID, fetchDetail)
  yield takeEvery(RtwInventoryTypes.PUT_RTW_INVENTORY, fetchPutData)
}

export default rtwInventorySaga
